import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import {
  MeasureItem,
  MeasuresInput,
} from "@/components/pages/edit/GraphTabs/Data/MeasureSelector";
import { useContext } from "react";
import { useGraphConfig } from "@/store/contexts/GraphConfigContext";
import GraphConfigFormContext from "@/store/contexts/GraphConfigFormContext";
import { useTranslation } from "react-i18next";

type MeasuresSectionProps = {};

const MeasuresSection = ({}: MeasuresSectionProps) => {
  const { fields } = useGraphConfig();
  const { config, setConfig } = useContext(GraphConfigFormContext);
  const { t } = useTranslation();

  if (!config) return null;

  // Handle only_count change
  const handleOnlyCountChange = (newValue: boolean) => {
    setConfig({
      ...config,
      graph_options: {
        ...config.graph_options,
        only_count: newValue,
      },
    });
  };

  // Handle measures change
  const handleMeasuresChange = (newMeasures: any[]) => {
    setConfig({
      ...config,
      graph_options: {
        ...config.graph_options,
        measures: newMeasures,
      },
    });
  };

  return (
    <div className="flex flex-col gap-4 py-4">
      <div className="flex flex-row w-full items-center justify-between">
        <div className="flex flex-col gap-1">
          <Label htmlFor="only_count" className="flex flex-col items-start">
            <span>{t("editor.graphConfig.data.onlyCount")}</span>
            <p className="text-xs text-muted-foreground">
              {t("editor.graphConfig.data.onlyCountDescription")}
            </p>
          </Label>
        </div>
        <Switch
          id="only_count"
          checked={config.graph_options.only_count}
          onCheckedChange={handleOnlyCountChange}
        />
      </div>

      {!config.graph_options.only_count && (
        <div className="mt-4">
          <MeasuresInput
            measures={config.graph_options.measures as MeasureItem[]}
            fields={fields}
            onChange={handleMeasuresChange}
          />
        </div>
      )}
    </div>
  );
};

export default MeasuresSection;
